"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6688],{

/***/ 1274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.11997 14.7101L12 10.8301L15.88 14.7101C16.27 15.1001 16.9 15.1001 17.29 14.7101C17.68 14.3201 17.68 13.6901 17.29 13.3001L12.7 8.7101C12.31 8.3201 11.68 8.3201 11.29 8.7101L6.69997 13.3001C6.30997 13.6901 6.30997 14.3201 6.69997 14.7101C7.08997 15.0901 7.72997 15.1001 8.11997 14.7101Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 2412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 26688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WP": function() { return /* binding */ MinimalPositionCard; },
/* harmony export */   "uK": function() { return /* binding */ StableFullPositionCard; }
/* harmony export */ });
/* unused harmony exports CustomStyledCard, StableFullPositionCardContainer */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82125);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(20353);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(88896);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(70257);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(94998);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(1274);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(57049);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(2412);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(96484);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(19521);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12966);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52775);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19639);
/* harmony import */ var hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2629);
/* harmony import */ var utils_prices__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(98045);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29315);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56974);
/* harmony import */ var views_RemoveLiquidity_RemoveStableLiquidity_hooks_useStableDerivedBurnInfo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89216);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12353);
/* harmony import */ var _state_wallet_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5460);
/* harmony import */ var _utils_currencyId__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(29159);
/* harmony import */ var _utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73938);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95934);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(941);
/* harmony import */ var _Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44787);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19259);
/* harmony import */ var _Layout_Row__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30445);
/* harmony import */ var _Loader_Dots__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32519);
/* harmony import */ var _utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59604);
/* harmony import */ var _state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47455);
/* harmony import */ var components_QuestionHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(72566);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 50px;\n  padding: 10px 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        " !important;\n  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01); \n  box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.08) inset; \n  border-radius: 30px !important;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























var FixedHeightRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowBetween */ .m0).withConfig({
    componentId: "sc-aa1ea2af-0"
})(_templateObject());
var CustomStyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z).withConfig({
    componentId: "sc-aa1ea2af-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.liquidityBorder;
});
var useTokensDeposited = function(param) {
    var pair = param.pair, totalPoolTokens = param.totalPoolTokens, userPoolBalance = param.userPoolBalance;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(!!pair && !!totalPoolTokens && !!userPoolBalance && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalPoolTokens.quotient, userPoolBalance.quotient) ? [
        pair.getLiquidityValue(pair.token0, totalPoolTokens, userPoolBalance, false),
        pair.getLiquidityValue(pair.token1, totalPoolTokens, userPoolBalance, false), 
    ] : [
        undefined,
        undefined
    ], 2), token0Deposited = ref[0], token1Deposited = ref[1];
    return [
        token0Deposited,
        token1Deposited
    ];
};
var useTotalUSDValue = function(param) {
    var currency0 = param.currency0, currency1 = param.currency1, token0Deposited = param.token0Deposited, token1Deposited = param.token1Deposited;
    var token0Price = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(currency0);
    var token1Price = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(currency1);
    var token0USDValue = token0Deposited && token0Price ? (0,utils_prices__WEBPACK_IMPORTED_MODULE_26__/* .multiplyPriceByAmount */ .a)(token0Price, parseFloat(token0Deposited.toSignificant(6))) : null;
    var token1USDValue = token1Deposited && token1Price ? (0,utils_prices__WEBPACK_IMPORTED_MODULE_26__/* .multiplyPriceByAmount */ .a)(token1Price, parseFloat(token1Deposited.toSignificant(6))) : null;
    return token0USDValue && token1USDValue ? token0USDValue + token1USDValue : null;
};
var usePoolTokenPercentage = function(param) {
    var userPoolBalance = param.userPoolBalance, totalPoolTokens = param.totalPoolTokens;
    return !!userPoolBalance && !!totalPoolTokens && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalPoolTokens.quotient, userPoolBalance.quotient) ? new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .Percent */ .gG(userPoolBalance.quotient, totalPoolTokens.quotient) : undefined;
};
var withLPValuesFactory = function(param) {
    var useLPValuesHook = param.useLPValuesHook, hookArgFn = param.hookArgFn;
    return function(Component) {
        return function(props) {
            var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useWeb3React */ .Ge)().account;
            var currency0 = props.showUnwrapped ? props.pair.token0 : (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__/* .unwrappedToken */ .Bv)(props.pair.token0);
            var currency1 = props.showUnwrapped ? props.pair.token1 : (0,_utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_13__/* .unwrappedToken */ .Bv)(props.pair.token1);
            var userPoolBalance = (0,_state_wallet_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useTokenBalance */ .mM)(account !== null && account !== void 0 ? account : undefined, props.pair.liquidityToken);
            var totalPoolTokens = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props.pair.liquidityToken);
            var poolTokenPercentage = usePoolTokenPercentage({
                totalPoolTokens: totalPoolTokens,
                userPoolBalance: userPoolBalance
            });
            var args = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
                return hookArgFn({
                    userPoolBalance: userPoolBalance,
                    pair: props.pair,
                    totalPoolTokens: totalPoolTokens
                });
            }, [
                userPoolBalance,
                props.pair,
                totalPoolTokens
            ]);
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(useLPValuesHook(args), 2), token0Deposited = ref[0], token1Deposited = ref[1];
            var totalUSDValue = useTotalUSDValue({
                currency0: currency0,
                currency1: currency1,
                token0Deposited: token0Deposited,
                token1Deposited: token1Deposited
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({}, props), {
                currency0: currency0,
                currency1: currency1,
                token0Deposited: token0Deposited,
                token1Deposited: token1Deposited,
                totalUSDValue: totalUSDValue,
                userPoolBalance: userPoolBalance,
                poolTokenPercentage: poolTokenPercentage
            }));
        };
    };
};
var withLPValues = withLPValuesFactory({
    useLPValuesHook: useTokensDeposited,
    hookArgFn: function(param) {
        var pair = param.pair, userPoolBalance = param.userPoolBalance, totalPoolTokens = param.totalPoolTokens;
        return {
            pair: pair,
            userPoolBalance: userPoolBalance,
            totalPoolTokens: totalPoolTokens
        };
    }
});
var withStableLPValues = withLPValuesFactory({
    useLPValuesHook: views_RemoveLiquidity_RemoveStableLiquidity_hooks_useStableDerivedBurnInfo__WEBPACK_IMPORTED_MODULE_10__/* .useGetRemovedTokenAmounts */ .N,
    hookArgFn: function(param) {
        var userPoolBalance = param.userPoolBalance;
        var ref;
        return {
            lpAmount: userPoolBalance === null || userPoolBalance === void 0 ? void 0 : (ref = userPoolBalance.quotient) === null || ref === void 0 ? void 0 : ref.toString()
        };
    }
});
function MinimalPositionCardView(param) {
    var pair = param.pair, currency0 = param.currency0, currency1 = param.currency1, token0Deposited = param.token0Deposited, token1Deposited = param.token1Deposited, totalUSDValue = param.totalUSDValue, userPoolBalance = param.userPoolBalance, poolTokenPercentage = param.poolTokenPercentage;
    var isStableLP = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext */ .UA);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var poolData = (0,_state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useLPApr */ .aT)(pair);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(t("Based on last 7 days' performance. Does not account for impermanent loss"), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: userPoolBalance && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThan */ .QA.greaterThan(userPoolBalance.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__/* .BIG_INT_ZERO */ .iV) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedHeightRow, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                fontSize: "18px",
                                bold: true,
                                children: t("LP tokens in your wallet")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_17__/* .DoubleCurrencyLogo */ .ge, {
                                        currency0: currency0,
                                        currency1: currency1,
                                        margin: true,
                                        size: 30
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        fontFamily: "Syconpate, sans-serif",
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        letterSpacing: "-0.03em",
                                        children: [
                                            currency0.symbol,
                                            "-",
                                            currency1.symbol
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            children: userPoolBalance ? userPoolBalance.toSignificant(4) : "-"
                                        }),
                                        Number.isFinite(totalUSDValue) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            small: true,
                                            color: "textSubtle",
                                            children: "~".concat(totalUSDValue.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }), " USD")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                        gap: "4px",
                        children: [
                            poolData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                        ref: targetRef,
                                        color: "textSubtle",
                                        small: true,
                                        children: t("LP reward APR")
                                    }),
                                    tooltipVisible && tooltip,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        children: [
                                            (0,_utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__/* .formatAmount */ .d)(poolData.lpApr7d),
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: [
                                            t("Share of Pool"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        children: poolTokenPercentage ? "".concat(poolTokenPercentage.toFixed(6), "%") : "-"
                                    })
                                ]
                            }),
                            isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: t("Pooled %asset%", {
                                            asset: currency0.symbol
                                        })
                                    }),
                                    token0Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            ml: "6px",
                                            children: token0Deposited === null || token0Deposited === void 0 ? void 0 : token0Deposited.toSignificant(6)
                                        })
                                    }) : "-"
                                ]
                            }),
                            isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        color: "textSubtle",
                                        small: true,
                                        children: t("Pooled %asset%", {
                                            asset: currency1.symbol
                                        })
                                    }),
                                    token1Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            ml: "6px",
                                            children: token1Deposited === null || token1Deposited === void 0 ? void 0 : token1Deposited.toSignificant(6)
                                        })
                                    }) : "-"
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Card__WEBPACK_IMPORTED_MODULE_14__/* .LightCard */ .hl, {})
    });
}
function FullPositionCard(_param) {
    var pair = _param.pair, currency0 = _param.currency0, currency1 = _param.currency1, token0Deposited = _param.token0Deposited, token1Deposited = _param.token1Deposited, totalUSDValue = _param.totalUSDValue, userPoolBalance = _param.userPoolBalance, poolTokenPercentage = _param.poolTokenPercentage, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(_param, [
        "pair",
        "currency0",
        "currency1",
        "token0Deposited",
        "token1Deposited",
        "totalUSDValue",
        "userPoolBalance",
        "poolTokenPercentage"
    ]);
    var isStableLP = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext */ .UA);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var poolData = (0,_state_swap_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useLPApr */ .aT)(pair);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var width = (0,_state_wallet_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useWindowDimensions */ .dz)().width;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_23__/* .useTheme */ .Fg)();
    var responsiveFont = width >= 500 ? 18 : 14;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CustomStyledCard, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({
        isActive: showMore
    }, props), {
        background: "transparent !important",
        mb: "0px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                justifyContent: "space-between",
                role: "button",
                onClick: function() {
                    return setShowMore(!showMore);
                },
                p: "20px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                mr: "10px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_17__/* .DoubleCurrencyLogo */ .ge, {
                                    currency0: currency0,
                                    currency1: currency1,
                                    size: 30
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                bold: true,
                                                className: "syncopate",
                                                children: !currency0 || !currency1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Loader_Dots__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    children: t("Loading")
                                                }) : "".concat(currency0.symbol, "/").concat(currency1.symbol)
                                            }),
                                            isStableLP ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                color: "textSubtle",
                                                ml: "4px",
                                                children: [
                                                    " ",
                                                    "- Stable"
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                fontWeight: 500,
                                                fontSize: responsiveFont,
                                                color: "text",
                                                children: userPoolBalance === null || userPoolBalance === void 0 ? void 0 : userPoolBalance.toSignificant(4)
                                            }),
                                            Number.isFinite(totalUSDValue) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                ml: "5px",
                                                fontWeight: 500,
                                                fontSize: responsiveFont,
                                                color: "textSubtle",
                                                children: "(~".concat(totalUSDValue.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }), " USD)")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {})
                ]
            }),
            showMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_15__/* .AutoColumn */ .Tz, {
                gap: "0px",
                style: {
                    paddingBottom: "20px"
                },
                children: [
                    isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        style: {
                            borderTop: "1px solid ".concat(theme.colors.liquidityBorder)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        size: "20px",
                                        currency: currency0
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        fontSize: responsiveFont,
                                        color: "textSubtle",
                                        ml: "4px",
                                        children: t("Pooled %asset%", {
                                            asset: currency0.symbol
                                        })
                                    })
                                ]
                            }),
                            token0Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                    fontSize: responsiveFont,
                                    ml: "6px",
                                    children: token0Deposited === null || token0Deposited === void 0 ? void 0 : token0Deposited.toSignificant(6)
                                })
                            }) : "-"
                        ]
                    }),
                    isStableLP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        style: {
                            borderTop: "1px solid ".concat(theme.colors.liquidityBorder)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo_CurrencyLogo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        size: "20px",
                                        currency: currency1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        fontSize: responsiveFont,
                                        color: "textSubtle",
                                        ml: "4px",
                                        children: t("Pooled %asset%", {
                                            asset: currency1.symbol
                                        })
                                    })
                                ]
                            }),
                            token1Deposited ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                    fontSize: responsiveFont,
                                    ml: "6px",
                                    children: token1Deposited === null || token1Deposited === void 0 ? void 0 : token1Deposited.toSignificant(6)
                                })
                            }) : "-"
                        ]
                    }),
                    poolData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        style: {
                            borderTop: "1px solid ".concat(theme.colors.modalBg)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Row__WEBPACK_IMPORTED_MODULE_18__/* .RowFixed */ .DA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                        fontSize: responsiveFont,
                                        color: "textSubtle",
                                        children: t("LP reward APR")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_QuestionHelper__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        text: t("Based on last 7 days' performance. Does not account for impermanent loss"),
                                        ml: "7px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                fontSize: responsiveFont,
                                children: [
                                    (0,_utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_20__/* .formatAmount */ .d)(poolData.lpApr7d),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FixedHeightRow, {
                        style: {
                            borderTop: "1px solid ".concat(theme.colors.liquidityBorder)
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                fontSize: responsiveFont,
                                color: "textSubtle",
                                children: t("Share of Pool")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                fontSize: responsiveFont,
                                children: poolTokenPercentage ? "".concat(poolTokenPercentage.toFixed(2) === "0.00" ? "<0.01" : poolTokenPercentage.toFixed(2), "%") : "-"
                            })
                        ]
                    }),
                    userPoolBalance && _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_3__/* .JSBI.greaterThan */ .QA.greaterThan(userPoolBalance.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_9__/* .BIG_INT_ZERO */ .iV) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                        flexDirection: "row",
                        p: "10px 20px 0",
                        style: {
                            gap: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                as: components_NextLink__WEBPACK_IMPORTED_MODULE_4__/* .NextLinkFromReactRouter */ .a,
                                to: "/remove/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_38__/* .currencyId */ .H)(currency0), "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_38__/* .currencyId */ .H)(currency1)).concat(isStableLP ? "?stable=1" : ""),
                                variant: "pinkPred",
                                width: "50%",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z, {
                                    width: 24,
                                    height: 24,
                                    mb: "2px",
                                    color: "text"
                                }),
                                className: "syncopate",
                                style: {
                                    textTransform: "uppercase",
                                    fontSize: "14px"
                                },
                                children: t("Remove")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                                as: components_NextLink__WEBPACK_IMPORTED_MODULE_4__/* .NextLinkFromReactRouter */ .a,
                                to: "/add/".concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_38__/* .currencyId */ .H)(currency0), "/").concat((0,_utils_currencyId__WEBPACK_IMPORTED_MODULE_38__/* .currencyId */ .H)(currency1), "?step=1"),
                                variant: "greenPred",
                                width: "50%",
                                startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
                                    width: 24,
                                    height: 24,
                                    mb: "2px",
                                    color: "text"
                                }),
                                className: "syncopate",
                                style: {
                                    textTransform: "uppercase",
                                    fontSize: "14px"
                                },
                                children: t("Add")
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var MinimalPositionCard = withLPValues(MinimalPositionCardView);
var StableFullPositionCardContainer = withStableLPValues(FullPositionCard);
var StableFullPositionCard = function(props) {
    var ref, ref1;
    var _ref = (0,views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)({
        tokenA: (ref = props.pair) === null || ref === void 0 ? void 0 : ref.token0,
        tokenB: (ref1 = props.pair) === null || ref1 === void 0 ? void 0 : ref1.token1
    }), stableSwapConfig = _ref.stableSwapConfig, config = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(_ref, [
        "stableSwapConfig"
    ]);
    if (!stableSwapConfig) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_11__/* .StableConfigContext.Provider */ .UA.Provider, {
        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({
            stableSwapConfig: stableSwapConfig
        }, config),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StableFullPositionCardContainer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (withLPValues(FullPositionCard));


/***/ }),

/***/ 92015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ useBurnActionHandlers; },
/* harmony export */   "Vx": function() { return /* binding */ useDerivedBurnInfo; },
/* harmony export */   "Xi": function() { return /* binding */ useBurnState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97477);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73938);
/* harmony import */ var hooks_usePairs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71633);
/* harmony import */ var hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19639);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68492);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88453);
/* harmony import */ var _wallet_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5460);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54820);














function useBurnState() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.burn;
    });
}
function useDerivedBurnInfo(currencyA, currencyB, removalCheckedA, removalCheckedB, zapMode) {
    var ref, ref1, ref2;
    var ref3 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), account = ref3.account, chainId = ref3.chainId;
    var ref4 = useBurnState(), independentField = ref4.independentField, typedValue = ref4.typedValue;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    // pair + totalsupply
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,hooks_usePairs__WEBPACK_IMPORTED_MODULE_5__/* .usePair */ .yX)(currencyA, currencyB), 2), pair = ref5[1];
    // balances
    var relevantTokenBalances = (0,_wallet_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useTokenBalances */ .Z)(account !== null && account !== void 0 ? account : undefined, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken
    ]);
    var ref6;
    var userLiquidity = relevantTokenBalances === null || relevantTokenBalances === void 0 ? void 0 : relevantTokenBalances[(ref6 = pair === null || pair === void 0 ? void 0 : (ref = pair.liquidityToken) === null || ref === void 0 ? void 0 : ref.address) !== null && ref6 !== void 0 ? ref6 : ""];
    var ref7 = [
        (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__/* .wrappedCurrency */ .pu)(currencyA, chainId),
        (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_4__/* .wrappedCurrency */ .pu)(currencyB, chainId)
    ], tokenA = ref7[0], tokenB = ref7[1];
    var _obj;
    var tokens = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, tokenA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, tokenB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY, pair === null || pair === void 0 ? void 0 : pair.liquidityToken), _obj);
    // liquidity values
    var totalSupply = (0,hooks_useTotalSupply__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pair === null || pair === void 0 ? void 0 : pair.liquidityToken);
    var liquidityValueA = pair && totalSupply && userLiquidity && tokenA && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalSupply.quotient, userLiquidity.quotient) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, pair.getLiquidityValue(tokenA, totalSupply, userLiquidity, false).quotient) : undefined;
    var liquidityValueB = pair && totalSupply && userLiquidity && tokenB && // this condition is a short-circuit in the case where useTokenBalance updates sooner than useTotalSupply
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThanOrEqual */ .QA.greaterThanOrEqual(totalSupply.quotient, userLiquidity.quotient) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, pair.getLiquidityValue(tokenB, totalSupply, userLiquidity, false).quotient) : undefined;
    var _obj1;
    var liquidityValues = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, liquidityValueA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, liquidityValueB), _obj1);
    var percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("0", "100");
    // user specified a %
    if (independentField === _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT) {
        percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(typedValue, "100");
    } else if (independentField === _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY) {
        if (pair === null || pair === void 0 ? void 0 : pair.liquidityToken) {
            var independentAmount = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(typedValue, pair.liquidityToken);
            if (independentAmount && userLiquidity && !independentAmount.greaterThan(userLiquidity)) {
                percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(independentAmount.quotient, userLiquidity.quotient);
            }
        }
    } else if (tokens[independentField]) {
        var independentAmount1 = (0,_pancakeswap_utils_tryParseAmount__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(typedValue, tokens[independentField]);
        var liquidityValue = liquidityValues[independentField];
        if (independentAmount1 && liquidityValue && !independentAmount1.greaterThan(liquidityValue)) {
            percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(independentAmount1.quotient, liquidityValue.quotient);
        }
    }
    var liquidityToRemove = userLiquidity && percentToRemove && percentToRemove.greaterThan("0") ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(userLiquidity.currency, percentToRemove.multiply(userLiquidity.quotient).quotient) : undefined;
    var tokenToReceive = removalCheckedA && removalCheckedB ? undefined : removalCheckedA ? (ref1 = tokens[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A]) === null || ref1 === void 0 ? void 0 : ref1.address : (ref2 = tokens[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) === null || ref2 === void 0 ? void 0 : ref2.address;
    var amountA = tokenA && percentToRemove && percentToRemove.greaterThan("0") && liquidityValueA ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, percentToRemove.multiply(liquidityValueA.quotient).quotient) : undefined;
    var amountB = tokenB && percentToRemove && percentToRemove.greaterThan("0") && liquidityValueB ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, percentToRemove.multiply(liquidityValueB.quotient).quotient) : undefined;
    var tokenAmountToZap = removalCheckedA && removalCheckedB ? undefined : removalCheckedA ? amountB : amountA;
    var estimateZapOutAmount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (pair && tokenAmountToZap) {
            try {
                return pair.getOutputAmount(tokenAmountToZap)[0];
            } catch (error) {
                return undefined;
            }
        }
        return undefined;
    }, [
        pair,
        tokenAmountToZap
    ]);
    var _obj2;
    var parsedAmounts = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, percentToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY, liquidityToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A, !zapMode ? amountA : amountA && removalCheckedA && !removalCheckedB && estimateZapOutAmount ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenA, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.add */ .QA.add(percentToRemove.multiply(liquidityValueA.quotient).quotient, estimateZapOutAmount.quotient)) : !removalCheckedA ? undefined : amountA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj2, _actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B, !zapMode ? amountB : amountB && removalCheckedB && !removalCheckedA && estimateZapOutAmount ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(tokenB, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.add */ .QA.add(percentToRemove.multiply(liquidityValueB.quotient).quotient, estimateZapOutAmount.quotient)) : !removalCheckedB ? undefined : amountB), _obj2);
    var error;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (!parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.LIQUIDITY */ .g.LIQUIDITY] || removalCheckedA && !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_A */ .g.CURRENCY_A] || removalCheckedB && !parsedAmounts[_actions__WEBPACK_IMPORTED_MODULE_11__/* .Field.CURRENCY_B */ .g.CURRENCY_B]) {
        error = error !== null && error !== void 0 ? error : t("Enter an amount");
    }
    return {
        pair: pair,
        parsedAmounts: parsedAmounts,
        error: error,
        tokenToReceive: tokenToReceive,
        estimateZapOutAmount: estimateZapOutAmount
    };
}
function useBurnActionHandlers() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_9__/* .useAppDispatch */ .TL)();
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(field, typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_11__/* .typeInput */ .L)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    return {
        onUserInput: onUserInput
    };
}


/***/ }),

/***/ 89216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useStableDerivedBurnInfo; },
/* harmony export */   "N": function() { return /* binding */ useGetRemovedTokenAmounts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82125);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97477);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52775);
/* harmony import */ var state_burn_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54820);
/* harmony import */ var state_wallet_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5460);
/* harmony import */ var state_burn_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92015);
/* harmony import */ var views_AddLiquidity_AddStableLiquidity_hooks_useStableLPDerivedMintInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24651);
/* harmony import */ var views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12353);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8100);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);














function useGetRemovedTokenAmounts(param) {
    var lpAmount = param.lpAmount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(views_Swap_StableSwap_hooks_useStableConfig__WEBPACK_IMPORTED_MODULE_7__/* .StableConfigContext */ .UA), stableSwapInfoContract = ref.stableSwapInfoContract, stableSwapConfig = ref.stableSwapConfig;
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(!lpAmount ? null : [
        "stableSwapInfoContract",
        "calc_coins_amount",
        stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress,
        lpAmount
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            return [
                2,
                stableSwapInfoContract.calc_coins_amount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.stableSwapAddress, lpAmount)
            ];
        });
    })).data;
    if (!Array.isArray(data)) return [];
    var tokenAAmount = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.token0, data[0].toString());
    var tokenBAmount = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(stableSwapConfig === null || stableSwapConfig === void 0 ? void 0 : stableSwapConfig.token1, data[1].toString());
    return [
        tokenAAmount,
        tokenBAmount
    ];
}
function useStableDerivedBurnInfo(currencyA, currencyB) {
    var ref, ref1;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().account;
    var ref2 = (0,state_burn_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useBurnState */ .Xi)(), independentField = ref2.independentField, typedValue = ref2.typedValue;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    // pair + totalsupply
    var pair = (0,views_AddLiquidity_AddStableLiquidity_hooks_useStableLPDerivedMintInfo__WEBPACK_IMPORTED_MODULE_6__/* .useStablePair */ .o)(currencyA === null || currencyA === void 0 ? void 0 : currencyA.wrapped, currencyB === null || currencyB === void 0 ? void 0 : currencyB.wrapped).pair;
    // balances
    var relevantTokenBalances = (0,state_wallet_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTokenBalances */ .Z)(account !== null && account !== void 0 ? account : undefined, [
        pair === null || pair === void 0 ? void 0 : pair.liquidityToken
    ]);
    var ref3;
    var userLiquidity = relevantTokenBalances === null || relevantTokenBalances === void 0 ? void 0 : relevantTokenBalances[(ref3 = pair === null || pair === void 0 ? void 0 : (ref = pair.liquidityToken) === null || ref === void 0 ? void 0 : ref.address) !== null && ref3 !== void 0 ? ref3 : ""];
    var percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("0", "100");
    // user specified a %
    if (independentField === state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT) {
        percentToRemove = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(typedValue, "100");
    }
    var liquidityToRemove = userLiquidity && percentToRemove && percentToRemove.greaterThan("0") ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(userLiquidity.currency, percentToRemove.multiply(userLiquidity.quotient).quotient) : undefined;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(useGetRemovedTokenAmounts({
        lpAmount: liquidityToRemove === null || liquidityToRemove === void 0 ? void 0 : (ref1 = liquidityToRemove.quotient) === null || ref1 === void 0 ? void 0 : ref1.toString()
    }), 2), amountA = ref4[0], amountB = ref4[1];
    console.log("Remove amount a b", amountA, amountB);
    var _obj;
    var parsedAmounts = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY_PERCENT */ .g.LIQUIDITY_PERCENT, percentToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY */ .g.LIQUIDITY, liquidityToRemove), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.CURRENCY_A */ .g.CURRENCY_A, amountA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.CURRENCY_B */ .g.CURRENCY_B, amountB), _obj);
    var error;
    if (!account) {
        error = t("Connect Wallet");
    }
    if (!parsedAmounts[state_burn_actions__WEBPACK_IMPORTED_MODULE_3__/* .Field.LIQUIDITY */ .g.LIQUIDITY]) {
        error = error !== null && error !== void 0 ? error : t("Enter an amount");
    }
    return {
        pair: pair,
        parsedAmounts: parsedAmounts,
        error: error
    };
}


/***/ })

}]);